export default __webpack_public_path__ + "static/media/11.d38d757e.png";